import { config } from "../../config";

export const CONTRACTS = {
  Celostrials: config.CELOSTRIALS_ADDRESS,
};
